// React
import { useContext } from "react"

// Components
import { NumberInput } from "components"

// Contexts
import { BillContext } from "../contexts"

// Form
import { useFormContext } from "react-hook-form"

// Types
import type { FormType } from "../utils"

export function BalanceBill(): JSX.Element {
  // Hooks
  const data = useContext(BillContext)

  // Form
  const { formState } = useFormContext<FormType>()

  if (formState.defaultValues?.trx_code && data.approve_status !== 1) {
    return <></>
  }

  return (
    <NumberInput
      disabled
      inputClass="text-right"
      label="BALANCE BILL"
      value={data.databill.balance}
    />
  )
}